import defaultAttributes from '../defaultAttributes';

const Bluetooth = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M7 7l10 10-5 5V2l5 5L7 17' }]],
];

export default Bluetooth;
